module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/3@2x_3e7f70c6f19ef43a8b2052aeb6323c62.png";